import { OrderByDirection } from "firebase/firestore";
import { CheckBoxItem } from "../components/checkBox/CheckBoxGroup";

/**
 * 編集確定または出欠確定時の出欠情報
 * @property id - ドキュメントID
 * @property messageId - お知らせID
 * @property title - お知らせタイトル
 * @property publishTarget - 配信先（all | [companyId] | topic | token）
 * @property publishTargetList - 配信先グループ
 * @property eventVenue - 開催場所
 * @property sendDate - 配信日
 * @property eventAt - イベント開催日
 * @property eventType - イベントタイプ
 * @property isMunicipalityConfirmed - 編集確定状況
 * @property userId - 団体番号含む利用者ID
 * @property userDisplayId - 表示時の利用者ID
 * @property lastName - 利用者名
 * @property readAt - 既読日時
 * @property deleteFlg - アプリ利用可否
 * @property confirmationCheck - チェック状態
 * @property replyButtonName - 返信データ
 * @property attendanceButtonName - 出欠データ
 * @property participationFlg - 配信外フラグ
 * @property createdAt - レコード作成日
 * @property updatedAt - レコード更新日
 */
export type EventParticipationHistory = {
  id?: string;
  messageId: string;
  title: string;
  publishTarget: string;
  publishTargetList: string[];
  eventVenue: string | null;
  sendDate: Date;
  eventAt: Date;
  eventType: string | null;
  isMunicipalityConfirmed: boolean;
  isStaffConfirmed: boolean;
  userId: string;
  userDisplayId: string;
  lastName: string; 
  readAt: Date | null;
  deleteFlg: boolean | null;
  confirmationCheck: boolean;
  replyButtonName: string;
  attendanceButtonName?: string;
  participationFlg: boolean;
  createdAt: Date;
  updatedAt: Date;
  tenantId: string;
};

/** 検索用 */
export type EventParticipationHistorySearchParam = {
  messageId: string;
  replyListValue: CheckBoxItem[];
  attendanceListValue: CheckBoxItem[];
  publishTarget: string;
  searchGroups: CheckBoxItem[];
  userId: string;
  lastName: string;
  title: string;
  eventVenue: string;
  sendDateStart: string;
  sendDateEnd: string;
  eventAtStart: string;
  eventAtEnd: string;
  eventType: string;
  stringCombinationSearchFlg: boolean;
  timestampCombinationSearchFlg: boolean;
};

/** firestoreから取得したデータのマッピング */
export const EventParticipationTimestampToDate = (data: any): EventParticipationHistory => {
  if (data.sendDate != null)data.sendDate = new Date(data.sendDate.seconds * 1000);
  if (data.eventAt != null)data.eventAt = new Date(data.eventAt.seconds * 1000);
  if (data.readAt != null) data.readAt = new Date(data.readAt.seconds * 1000);
  if (data.createdAt != null)data.createdAt = new Date(data.createdAt.seconds * 1000);
  if (data.updatedAt != null)data.updatedAt = new Date(data.updatedAt.seconds * 1000);
  return data;
}

/** ソート用 */
export type EventParticipationAttendanceHistorySortParam = {
  title: OrderByDirection | null;
  eventAt: OrderByDirection | null;
};

// rdbから取得したイベント参加履歴一覧のデータのマッピング
export const RdbEventParticipationHistoryMapping = (data: any | undefined): EventParticipationHistory => {
  const result: EventParticipationHistory = {
    messageId: data.message_id,
    title: data.title,
    publishTarget: data.publish_target,
    publishTargetList: [],
    eventVenue: data.event_venue,
    sendDate: new Date(data.send_date),
    eventAt: new Date(data.event_at),
    eventType: null,
    isMunicipalityConfirmed: true,
    isStaffConfirmed: false,
    userId: data.user_id,
    userDisplayId: data.user_display_id,
    lastName: data.last_name,
    readAt: null,
    deleteFlg: null,
    confirmationCheck: false,
    replyButtonName: data.reply_button_name,
    attendanceButtonName: data.attendance_button_name,
    participationFlg: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    tenantId: ''
  }

  return result;
}